import { useMaskPII } from 'hooks/useMaskPII';

export const testId = 'addressItemTestId';

type Address = {
  displayName?: string;
  postcode?: string;
};

type AddressItemProps = {
  address?: Address;
  fuel?: string;
  hasTitle?: boolean;
};

export const AddressItem = ({ fuel = '', address, hasTitle = true }: AddressItemProps) => {
  const { mask } = useMaskPII();

  if (!address) {
    return null;
  }

  return (
    <div data-testid={testId}>
      {hasTitle && (
        <p>
          <strong>For {fuel.toLowerCase()}</strong>
        </p>
      )}
      <p>
        {address.displayName &&
          address.displayName.split(',').map((f, index) => (
            <span key={index} {...mask}>
              {f}
              <br />
            </span>
          ))}
        <span {...mask}>{address.postcode}</span>
      </p>
    </div>
  );
};
